/*
  Example page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col } from 'react-bootstrap'
import ExampleComponent from '../components/route/Example'

function Example () {
  return (
    <>
      <Helmet>
        <title>Example - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col>
            <ExampleComponent />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Example
